export default $ => {
  $('[data-datepicker]').each(function () {
    const self = $(this);
    let onSelect = null;

    const relatedStart = self.data('datepicker-start');
    if (relatedStart) {
      onSelect = dateText => {
        $(relatedStart).datepicker('option', 'maxDate', dateText);
      };
    }

    const relatedEnd = self.data('datepicker-end');
    if (relatedEnd) {
      onSelect = dateText => {
        $(relatedEnd).datepicker('option', 'minDate', dateText);
      };
    }

    self.datepicker({dateFormat: 'dd/mm/yy', onSelect});
    self.datepicker('option', $.datepicker.regional[window.app.locale]);
    self.datepicker('option', {prevText: '<', nextText: '>'});
  });
};



// WEBPACK FOOTER //
// ./assets/js/component/calendar.js